import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useCallback, useMemo } from 'react';
import { useLocalizationContext } from './useLocalization';
export var useTranslate = function useTranslate() {
  var _useLocalizationConte = useLocalizationContext(),
    isEditingEnabled = _useLocalizationConte.isEditingEnabled,
    isShowKeyEnabled = _useLocalizationConte.isShowKeyEnabled,
    localizationService = _useLocalizationConte.localizationService,
    resourceIsLoaded = _useLocalizationConte.resourceIsLoaded,
    resourceSetIsLoaded = _useLocalizationConte.resourceSetIsLoaded,
    showLogs = _useLocalizationConte.showLogs;
  var doNotTranslate = useCallback(function (key, params) {
    return key;
  }, []);
  var translate = useCallback(function (key, params) {
    if (key.indexOf('.') < 1) {
      if (showLogs) console.warn("Invalid translate key '".concat(key, "'"));
      return key;
    }
    var translated = localizationService.translateInstant(key, {
      interpolateParams: params,
      returnKeyIfNotFound: false
    });
    if (translated === undefined) {
      // resource was not yet loaded
      var _key$split = key.split('.'),
        _key$split2 = _slicedToArray(_key$split, 1),
        resource = _key$split2[0];
      var status = resourceIsLoaded(resource);
      if (status === undefined) {
        resourceSetIsLoaded(resource, false);
        localizationService.translate(key, {
          interpolateParams: params
        }).then(function (res) {
          resourceSetIsLoaded(resource, true);
        })["catch"](function (e) {
          if (showLogs) console.warn('translate', e);
        });
      } else if (status) {
        // resource was loaded but key not found
        return key;
      }
    }
    return translated || '';
  }, [localizationService, resourceIsLoaded, resourceSetIsLoaded, showLogs]);
  return useMemo(function () {
    return isEditingEnabled && isShowKeyEnabled ? doNotTranslate : translate;
  }, [doNotTranslate, isEditingEnabled, isShowKeyEnabled, translate]);
};